import type { ImportAdapter } from '../types';
import { createZipImportAdapter } from './zip-import.adapter';

// =============================================================================
// CAMPAIGN BULK IMPORT ADAPTER
// =============================================================================

/**
 * Campaign Bulk Import Adapter
 *
 * Handles import of bulk campaigns (newsletters, promotions) from ZIP files.
 * Uses the shared ZIP import adapter factory for common functionality.
 *
 * Flow:
 * 1. User uploads a ZIP file containing bulk campaigns
 * 2. System calls describe-file API to list available campaigns
 * 3. User selects which campaigns to import
 * 4. System imports selected campaigns
 */
const baseAdapter = createZipImportAdapter({
  type: 'campaign_bulk',
  emptyFileErrorKey: 'import.itemSelector.noBulkFound',
  alternativeType: 'campaign',
});

export const campaignBulkAdapter: ImportAdapter = {
  ...baseAdapter,
  processingMode: 'immediate',
};

export default campaignBulkAdapter;
